/*
 * GOVX ID discount page — discount figure guard.
 *
 * The percentage in the app's own copy ("we've partnered with GOVX to offer a
 * 15% discount on our store") is a static string stored in the GOVX app
 * settings, not something the theme renders. The active Shopify rule discounts
 * 10%, so when the two disagree the page advertises a saving the checkout will
 * not apply.
 *
 * The real fix is the GOVX app setting. This is a guard so the storefront never
 * publishes a figure higher than the one customers actually receive. It only
 * rewrites a percentage that disagrees with the theme's configured value, it
 * touches nothing else in the injected markup, and if the provider changes the
 * wording it simply finds nothing and leaves the copy alone.
 */
(() => {
  const shell = document.querySelector('[data-nw-govx-discount]');

  if (!shell) return;

  const configured = Number.parseInt(shell.dataset.nwGovxDiscount, 10);

  if (!Number.isFinite(configured) || configured <= 0) return;

  const percentage = /(\d{1,2})\s*%/g;

  const correct = (node) => {
    const original = node.nodeValue;
    const corrected = original.replace(percentage, (match, value) =>
      Number.parseInt(value, 10) === configured ? match : match.replace(value, String(configured)),
    );

    if (corrected !== original) node.nodeValue = corrected;
  };

  const sweep = () => {
    const widget = shell.querySelector('[data-govx-id]');

    if (!widget) return;

    const walker = document.createTreeWalker(widget, NodeFilter.SHOW_TEXT);

    while (walker.nextNode()) {
      if (percentage.test(walker.currentNode.nodeValue)) {
        percentage.lastIndex = 0;
        correct(walker.currentNode);
      }
      percentage.lastIndex = 0;
    }
  };

  sweep();
  new MutationObserver(sweep).observe(shell, { childList: true, subtree: true, characterData: true });
})();
